import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { RoutesProvider } from "../app/RoutesProvider";
import { I18nProvider } from "../core/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../core/layout";

export default function App({ store, persistor, basename }) {
  return (
    <Provider store={store}>
        <React.Suspense fallback={<LayoutSplashScreen />}>
          <BrowserRouter basename={basename}>
            <MaterialThemeProvider>
              <I18nProvider>
                <RoutesProvider />
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
    </Provider>
  );
}
